import { apiService } from "constants/axiosInstance";

export const actionMoveProjectGroup = (data = {}) => {
  const config = {
    url: "/project-group/move",
    method: "post",
    data,
  };
  return apiService(config);
};
